import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import { ThemeProvider } from './contexts/ThemeContext';
import ScrollToTop from './components/ScrollToTop';
import { ToastProvider } from './contexts/ToastContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { Toaster } from 'react-hot-toast';
import Notifications from './pages/Notifications';
import LoadingSpinner from './components/LoadingSpinner';
import api from './services/api';

// Heartbeat component to keep session alive and update online status
const Heartbeat = () => {
  const { isAuthenticated } = useAuth();

  React.useEffect(() => {
    if (!isAuthenticated) return;

    // Send initial heartbeat
    api.dashboard.heartbeat().catch(err => console.error('Initial heartbeat failed:', err));

    // Send heartbeat every 2 minutes
    const interval = setInterval(() => {
      api.dashboard.heartbeat().catch(err => console.error('Periodic heartbeat failed:', err));
    }, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  return null;
};

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner size="medium" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Public Route component (redirects to dashboard if already authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner size="medium" />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

const App = () => {
  return (
    <>
      <Toaster />
      <Router>
        <ThemeProvider>
          <ToastProvider>
            {/* <NotificationProvider> */}
            <AuthProvider>
              <Heartbeat />
              <ScrollToTop />
              <AppRoutes />
            </AuthProvider>
            {/* </NotificationProvider> */}
          </ToastProvider>
        </ThemeProvider>
      </Router>
    </>
  );
};

export default App; 